"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var ImageUrlUtil = /** @class */ (function () {
    function ImageUrlUtil() {
    }
    ImageUrlUtil.resize = function (url, maxWidth, maxHeight) {
        var e_1, _a;
        if (maxWidth === void 0) { maxWidth = '-'; }
        if (maxHeight === void 0) { maxHeight = '-'; }
        var imgPrefix = '/img/';
        if (url === undefined || url === null || url.length == 0 || url.endsWith('.svg')) {
            return url;
        }
        var prefixes = [];
        prefixes.push('//static.test.aperza.com' + imgPrefix);
        prefixes.push('https://static.test.aperza.com' + imgPrefix);
        prefixes.push('//static.stg.aperza.com' + imgPrefix);
        prefixes.push('https://static.stg.aperza.com' + imgPrefix);
        prefixes.push('//static.aperza.com' + imgPrefix);
        prefixes.push('https://static.aperza.com' + imgPrefix);
        try {
            for (var prefixes_1 = __values(prefixes), prefixes_1_1 = prefixes_1.next(); !prefixes_1_1.done; prefixes_1_1 = prefixes_1.next()) {
                var prefix = prefixes_1_1.value;
                if (url.startsWith(prefix)) {
                    return (prefix.substring(0, prefix.length - imgPrefix.length) +
                        '/' +
                        maxWidth +
                        'x' +
                        maxHeight +
                        '/img/' +
                        url.substring(prefix.length));
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (prefixes_1_1 && !prefixes_1_1.done && (_a = prefixes_1.return)) _a.call(prefixes_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return url;
    };
    return ImageUrlUtil;
}());
exports.default = ImageUrlUtil;
//# sourceMappingURL=ImageUrlUtil.js.map